const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDIzVjIxSDVWMUg3VjJIMjEuMTI0N0wxOC4xMjYgNy45OTk5MUwyMS4xMjYgMTRIN1YyMUg4VjIzSDRaTTE3Ljg4OTMgNEg3VjEySDE3Ljg5TDE1Ljg5IDguMDAwMDlMMTcuODg5MyA0WiIvPgo8L3N2Zz4K";
export {
  M as default
};
//# sourceMappingURL=flag-eadfcc6a.mjs.map
